import Input from './input.vue';
export default Input;


// WEBPACK FOOTER //
// ./src/components/input/index.js